import { getLS, LocalStorageTypes } from '@/common/service/storage';

export const getWishlistLS = () => {
    const currentList = getLS(LocalStorageTypes.LS_WISH_LIST);
    const list: string[] = currentList ? currentList : [];

    return list;
};
